module.exports = "<div>\r\n    <sso-login></sso-login>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/component/sso/ssoLoginIndex.html
// module id = 218
// module chunks = 0